import React from "react";
import { Modal } from "@arco-design/web-react";

// MUI -> Arco. Dialog(+Title/Content/Actions) -> Modal with visible/onOk/
// onCancel/title; the Cancel/Delete DialogActions buttons become the Modal's
// okText/cancelText. Logic + props (open/onDelete/onClose) untouched.
export default function ContactListDeleteDialog({ open, onDelete, onClose }) {

  const handleClose = () => {
    onClose && onClose();
  };

  const handleDelete = () => {
    onDelete && onDelete();
    handleClose();
  };


  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      onOk={handleDelete}
      title="Delete Contact List (contacts will remain)"
      okText="Delete"
      cancelText="Cancel"
    >
      Are you sure you want to delete contact list?
    </Modal>
  );
}
